import { Component, OnInit } from '@angular/core';
import{FormGroup, FormControl,Validators, AbstractControl, NgForm}from '@angular/forms'
import {MentorService}from'../../services/mentors.service';
import Swal from 'sweetalert2';
import{Router}from'@angular/router'
import {bounceInX}from '../../../shared/animation/animation'
import { trigger, transition } from '@angular/animations';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],
  animations:[trigger('bounceInX',[
    transition(':enter',[bounceInX])]
    )]
})
export class SignupComponent implements OnInit {

  lang=['English','Hindi']
  eduList=['High School','Bachlors Degree','Masters Degree','Phd']
  countries=['India','USA'];
  form:FormGroup;
  submitted: boolean;
  constructor(private mentorService:MentorService,private router:Router) { 
    this.createForm()
    // this.countries=mentorService.getCountries();

  }
  ngOnInit() {
    
  }
 
  createForm(){
    this.form=new FormGroup({
      personalDetails:new FormGroup({
        firstName:new FormControl(null,[Validators.required,Validators.minLength(1),Validators.maxLength(50),Validators.pattern(/^[a-z]+$/i)]),
        lastName:new FormControl(null,[Validators.required,Validators.minLength(1),Validators.maxLength(50),Validators.pattern(/^[a-z]+$/i)]),
        languages:new FormControl(null,[Validators.required]),
        education:new FormControl(null,[Validators.required]),
        occupation:new FormControl(null,[Validators.required,Validators.minLength(1),Validators.maxLength(50)]),
        password:new FormControl(null,[Validators.required,Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)]),
        confirmPassword:new FormControl(null,[Validators.required]),
      },{validators:this.passMatch}),
      contactDetails:new FormGroup({
        country:new FormControl(null,[Validators.required]),
        state:new FormControl(null,[Validators.required,Validators.minLength(1),Validators.maxLength(100)]),
        city:new FormControl(null,[Validators.required,Validators.minLength(1),Validators.maxLength(100)]),
        address:new FormControl('',[Validators.required,Validators.minLength(1),Validators.maxLength(100)]),
        email:new FormControl(null,[Validators.required,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),
        phone:new FormControl(null,[Validators.required,Validators.pattern(/^[0-9]{10}$/)]),
        zip:new FormControl(null,[Validators.required,Validators.pattern(/^[0-9]{1,50}$/)]),
      }),
      additionalDetails:new FormGroup({
        mentoredBefore:new FormControl(null,[]),
        experience:new FormControl('',[Validators.maxLength(50)]),
        timeWillingToDonate:new FormControl(null,[Validators.pattern(/^[0-9]+$/),Validators.min(1),Validators.max(720)]),
        howLearntAboutKei:new FormControl(null,[Validators.maxLength(50)]),
        careerExperience:new FormControl(null ,[Validators.required,this.trim.bind(this),Validators.maxLength(50)])
      })
    })

}


//get reference of different form elements//
  get Fname(){
    return this.form.get('personalDetails.firstName')
  }
  get Lname(){
    return this.form.get('personalDetails.lastName')
  }
  get Lang(){
    return this.form.get('personalDetails.languages')
  }
  get Edu(){
    return this.form.get('personalDetails.education')
  }
  get Occupation(){
    return this.form.get('personalDetails.occupation')
  }
  get Pass(){
    return this.form.get('personalDetails.password')
  }
  get Cpass(){
    return this.form.get('personalDetails.confirmPassword')
  }
  get Country(){
    return this.form.get('contactDetails.country')
  }
  get State(){
    return this.form.get('contactDetails.state')
  }
  get City(){
    return this.form.get('contactDetails.city')
  }
  get Address(){
    return this.form.get('contactDetails.address')
  }
  get Zip(){
    return this.form.get('contactDetails.zip')
  }
  get Email(){
    return this.form.get('contactDetails.email')
  }
  get Phone(){
    return this.form.get('contactDetails.phone')
  }
  get Experience(){
    return this.form.get('additionalDetails.experience')
  }
  get Time(){
    return this.form.get('additionalDetails.timeWillingToDonate')
  }
  get How(){
    return this.form.get('additionalDetails.howLearntAboutKei')
  }
  get CareerExperience(){
    return this.form.get('additionalDetails.careerExperience')
  }
  //set the value//
  set Fname(val){
      this.form.get('personalDetails.fname').setValue(val)
  }
  set Lname(val){
      this.form.get('personalDetails.lname').setValue(val)
  }
  set Lang(val){
      this.form.get('personalDetails.lang').setValue(val)
  }
  set Edu(val){
    this.form.get('personalDetails.edu').setValue(val)
  }
  set Occupation(val){
    this.form.get('personalDetails.occupation').setValue(val)
  }
  set Pass(val){
   this.form.get('personalDetails.pass').setValue(val)
  }
  set Cpass(val){
    this.form.get('personalDetails.cpass').setValue(val)
  }
  set Country(val){
     this.form.get('contactDetails.country').setValue(val)
  }
  set State(val){
    this.form.get('contactDetails.state').setValue(val)
  }
  set City(val){
    this.form.get('contactDetails.city').setValue(val)
  }
  set Address(val){
     this.form.get('contactDetails.address').setValue(val)
  }
  set Zip(val){
     this.form.get('contactDetails.zip').setValue(val)
  }
  set Email(val){
    this.form.get('contactDetails.email').setValue(val)
  }
  set Phone(val){
    this.form.get('contactDetails.phone').setValue(val)
  }
  set Experience(val){
    this.form.get('additionalDetails.experience').setValue(val)
  }
  set Time(val){
    this.form.get('additionalDetails. timeWillingToDonate').setValue(val)
  }
  set How(val){
    this.form.get('additionalDetails.howLearntAboutKei').setValue(val)
  }
  set MentoredBefore(val){
    this.form.get('additionalDetails.mentoredBefore').setValue(val)
  }
  onSubmit(){
    if(this.form.invalid){
      this.submitted=true;
      return
    }
    if(this.form.valid){
       this.mentorService.register(this.form.value).subscribe(
            (result)=>{
                  Swal.fire({
                    title:'registered successfully',
                    text:'Your account is being reviewed, and you’ll be notified by email once approved',
                    type:'success',
                  }
                  )
                  this.router.navigate(['/'])

              
            },

            (err)=>{
                  if(err.status==400){
                    let errorMessage=err.error.error;
                    Swal.fire({
                    title:errorMessage,
                    type:'error',
                    }
                    )
                  }
                 
              }
        )
    
    
  }
    else{
      Swal.fire({
        title:"please enter required fields first",
        type:'error',
      }
      )
     
 
    }
  }
  reset(){
    // this.form.reset({
    //   'additionalDetails':{
    //     'mentoredBefore':'Yes'
    //   }
    // })
    // Object.keys(this.form.controls).forEach(key=>{
    //   this.form.controls[key].setErrors(null)
    // })
    this.router.navigate(['/'])

  
  }
  //custom validators//
  passMatch(group:AbstractControl){
   const password=group.get('password').value
   const confirmPassword=group.get('confirmPassword').value
   if(password===confirmPassword){
     return null
   }
   else{
    group.get('confirmPassword').setErrors({'misMatch':true})
    return {'misMatch':true}
   }
      
  }
  trim(control:AbstractControl){
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
        

  }

}